// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__2IWBb","column":"style_column__tqfhA","row":"style_row__3hbaQ"};